<template>
	<div class="user-pp-gallery">
		<CoolLightBox
			:items="items"
			:index="index"
			@close="index = null"
		></CoolLightBox>
		<div class="gallery-title">
			<h5>Gallery</h5>
		</div>
		<div class="row">
			<div
				v-for="(image, imageIndex) in images"
				:key="imageIndex"
				@click="index = imageIndex"
				class="col-lg-6 col-md-6 col-xl-3"
			>
				<div class="gallery-box">
					<img :src="image.url.original" :alt="image.title" />
					<div v-if="image.task" class="gallery-box-title">
						<h4>
							{{ image.task.category.title }} in
							{{ image.task.suburb.name }}
						</h4>
					</div>
					<div v-else class="gallery-box-title">
						<h4>{{ image.title }}</h4>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
export default {
	components: {
		CoolLightBox
	},
	props: {
		images: {
			type: [Array, Object],
			required: true
		}
	},
	data() {
		return {
			index: null,
			items: []
		};
	},
	created() {
		let self = this;
		this.images.forEach(function(item) {
			let img = {
				title: item.title,
				description: item.comment,
				src: item.url.original
			};

			if (
				item.task &&
				item.task.suburb.name &&
				item.task.category.title
			) {
				img.description =
					item.task.category.title + " in " + item.task.suburb.name;
			}

			self.items.push(img);
		});
	}
};
</script>
<style scoped></style>
